export type PluginInfo = {
  name: string;
  description: string;
  links: { github?: string; documentation: string };
};

const BLOOM_PLUGIN = {
  name: 'Bloom plugin for Enterprise',
  description:
    'The Bloom Enterprise plugin requires a valid licence key and facilitates access to a remote Neo4j databases ' +
    'as well as features used for collaboration, such as persistent storage and sharing capabilities ' +
    'for commercial users. To register for a license, please contact your Neo4j representative. ' +
    'All other Bloom features are available for free in the Explore tool without installing the plugin.',
  links: {
    documentation: 'https://neo4j.com/docs/bloom-user-guide/current/bloom-installation/installation-activation/',
  },
};

export const PLUGINS_INFO: Record<string, undefined | PluginInfo> = {
  apoc: {
    name: 'APOC',
    description:
      'The APOC library consists of many (about 450) procedures and functions to help with many different ' +
      'tasks in areas like collections manipulation, graph algorithms, and data conversion.',
    links: {
      github: 'https://github.com/neo4j/apoc',
      documentation: 'https://neo4j.com/docs/apoc/5/overview/',
    },
  },

  'neo4j-graph-data-science': {
    name: 'Graph Data Science',
    description:
      'The Neo4j Graph Data Science (GDS) plugin provides extensive analytical capabilities ' +
      'centered around graph algorithms. The plugin includes algorithms for community detection, ' +
      'centrality, similarity, path finding, and node embeddings, as well as graph catalog procedures ' +
      'and machine learning pipelines designed to support data science workflows for graphs. ' +
      'All operations are designed for massive scale and parallelisation, ' +
      'with a custom and general API tailored for graph-global processing, ' +
      'and highly optimised compressed in-memory data structures.',

    links: {
      documentation: 'https://neo4j.com/docs/graph-data-science/current/?ref=desktop',
      github: 'https://github.com/neo4j/graph-data-science/',
    },
  },

  'neo4j-genai-plugin': {
    name: 'Gen AI',
    description:
      "Neo4j's Vector indexes and Vector functions allow you to calculate the similarity between node and relationship " +
      'properties in a graph. A prerequisite for using these features is that vector embeddings have been set as properties ' +
      'of these entities. The GenAI plugin enables the creation of such embeddings using GenAI providers.',

    links: {
      documentation: 'https://neo4j.com/docs/cypher-manual/current/genai-integrations/',
    },
  },

  'bloom-plugin-4.x': {
    ...BLOOM_PLUGIN,
  },

  'bloom-plugin-5.x': {
    ...BLOOM_PLUGIN,
  },

  'bloom-plugin-6.x': {
    ...BLOOM_PLUGIN,
  },
};
